<div class="header-search">
    <ng-container *ngIf="searchOptions;else searchButtonContainer">
        <nb-form-field>
            <nb-icon nbPrefix icon="collapse-outline" pack="eva" (click)="toggleSearchButton()"></nb-icon>
            <input #search 
                type="text" 
                fieldSize="small" 
                nbInput 
                fullWidth 
                [nbAutocomplete]="autoControl"
                (keydown.enter)="onSearch(search.value)" 
                (focus)="onFocusEvent($event.target)" 
                (input)="lookUp($event.target.value)"
                [nbPopover]="templateRef"
                nbPopoverTrigger="noop"
                nbPopoverPlacement="bottom"
                nbPopoverAdjustment="noop"
                nbPopoverOffset=0>
            <!-- <button nbSuffix nbButton ghost (click)="filterOptionsActions()"> -->
                <nb-icon [icon]="filterOptions ? 'options-2-outline' : 'close-outline'"
                        pack="eva"
                        [attr.aria-label]="filterOptions ? 'Search Options' : 'Reset Search'"
                        (click)="filterOptionsActions()"
                        nbSuffix>
                </nb-icon>
            <!-- </button> -->
        </nb-form-field>
        <nb-autocomplete #autoControl>
            <nb-option *ngFor="let result of (results$ | async)" [value]="result?.id"
            (click)="selectLookUp($event)" 
            [attr.data-description]="result?.description" 
            [attr.data-value]="result?.id">
                <strong>{{result?.description}}</strong>  [{{result?.id}}]
            </nb-option>
        </nb-autocomplete>
        <ng-template #templateRef>
            <div class="find-form-container">
                <ubs-ofbiz-form [ofbizForm]="findForm" [title]="title" [state] ="state" (popoverClosed)="closePopover()" (seachResults)="getSearchResults($event)"></ubs-ofbiz-form>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #searchButtonContainer>
        <nb-actions size="small">
            <nb-action icon="search-outline" (click)="toggleSearchButton()"></nb-action>
        </nb-actions>
    </ng-template>
</div>
